import { render, staticRenderFns } from "./ActionDatabaseManagement.vue?vue&type=template&id=19e1dbac&scoped=true&"
import script from "./ActionDatabaseManagement.vue?vue&type=script&lang=js&"
export * from "./ActionDatabaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./ActionDatabaseManagement.vue?vue&type=style&index=0&id=19e1dbac&lang=less&scoped=true&"
import style1 from "./ActionDatabaseManagement.vue?vue&type=style&index=1&id=19e1dbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1dbac",
  null
  
)

export default component.exports